import React, { useMemo } from 'react';
import { useBoardChartData } from '../../hooks/useBoardChartData';
import { BaseChartProps } from './types';
import { CHART_COLORS, getCurrencySymbol, formatCompactNumber } from './chartTheme';
import { useSetChartMetadata } from './ChartContext';

export const NetProfitKPIChart: React.FC<BaseChartProps> = () => {
    const { finance, currencySettings } = useBoardChartData();

    const currencySymbol = useMemo(
        () => getCurrencySymbol(currencySettings?.default),
        [currencySettings?.default]
    );

    const netProfit = useMemo(
        () => finance?.total ?? 0,
        [finance?.total]
    );

    const isEmpty = useMemo(() => !finance || netProfit === 0, [finance, netProfit]);

    const color = useMemo(
        () => (netProfit >= 0 ? CHART_COLORS.revenue : CHART_COLORS.expense),
        [netProfit]
    );

    useSetChartMetadata({ isEmpty });

    return (
        <div className="flex h-full w-full items-center justify-center [container-type:inline-size]">
            <p
                className="font-semibold text-center"
                style={{
                    color,
                    fontSize: 'clamp(1.25rem, 8cqi, 2.5rem)',
                }}
            >
                {formatCompactNumber(netProfit, currencySymbol)}
            </p>
        </div>
    );
};
